import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/list', qs.stringify(params))
}

//获取明细
export const getDetail = (params) => {
  return axios.get(root + '/warehouse/jxcstoreform/detail', {params: params})
}


//删除行
export const deleteData = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/remove', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改

    return axios.post(root + '/warehouse/jxcstoreform/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/warehouse/jxcstoreform/save', qs.stringify(params))
  }
}
//生成出库单
export const saveOutboundData = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/saveOutbound', qs.stringify(params))
}

//生成出库单 新版
export const saveOutboundDataNew = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/saveOutboundNew', qs.stringify(params))

}

//获取出库单详细
export const getJxcformdetailGetList = (params) => {

  return axios.post(root + '/warehouse/jxcstoreformdetail/list', qs.stringify(params))

}

//获取物流公司和单号
export const getLogistics = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/getLogistics', qs.stringify(params))
}

//获取坏件库
export const getBadStoreListData = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/getBadStoreListData', qs.stringify(params))
}

//获取坏件库库存  2019-9-19 修改前
export const brokengoodslist = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/brokengoodslist', qs.stringify(params))
}
//获取坏件库库存 2019-9-19 修改后
export const badpartslist = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/badpartslist', qs.stringify(params))
}
// //盘点
// export const inventory = (params) => {
//   return axios.post(root + '/warehouse/store/inventory', qs.stringify(params))
// }
// //盘点
// export const inventorySave = (params) => {
//   return axios.post(root + '/set/jxcforms/inventorySave', qs.stringify(params))
// }

//获取期初数据
export const getSeedListWithMonth0Data = (params) => {
  return axios.post(root + '/warehouse/store/getSeedListWithMonth0Data', qs.stringify(params))
}

export const addstoragebad = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/addstoragebad', qs.stringify(params))
}
//坏件库导入
export const badpartsimport = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/badpartsimport', qs.stringify(params))
}
export const badneedbuy = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/badneedbuy', qs.stringify(params))
}


//导出盘点单
export const loadMakeInventory = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/loadMakeInventory', qs.stringify(params))

}



// WEBPACK FOOTER //
// ./src/api/set/warehouse.js